import { HistoryEventType } from '../../../../../Model/CoachHistory';

const texts = {
  eventText: {
    [HistoryEventType.WHITE_LISTED]: 'An onboarding link was sent to the coach.',
    [HistoryEventType.ACCOUNT_CREATED]: 'The coach created an account in the system.',
    [HistoryEventType.PROFILE_SET]: 'Coach profile was configured.',
    [HistoryEventType.STRIPE_CONNECTED]: 'Coach\'s Stripe account was created and connected.',
    [HistoryEventType.LEAD_FORM_CREATED]: 'Lead form for the coach was created.',
    [HistoryEventType.POST_PAYMENT_FORM_LINKED]: 'The post-payment form was linked to the coach.',
    [HistoryEventType.FIRST_PRODUCT_CREATED]: 'The first paid product was created.',
    [HistoryEventType.LOGO_SUBMITTED]: 'App logo was submitted for approval.',
    [HistoryEventType.LOGO_APPROVED]: 'The app logo was marked as "Approved by Coach".',
    [HistoryEventType.WEBSITE_SUBMITTED]: 'Website was submitted for approval.',
    [HistoryEventType.WEBSITE_APPROVED]: 'The website was marked as "Approved by Coach".',
    [HistoryEventType.WELCOME_PACK_SUBMITTED]: 'Welcome pack was submitted for approval.',
    [HistoryEventType.APP_LOGO_SET]: 'Mobile app logo was set up.',
    [HistoryEventType.APP_THEME_SET]: 'Mobile app theme was set up.',
    [HistoryEventType.SLACK_CHANNEL_SET]: 'Slack notification channel was configured.',
    [HistoryEventType.COACH_LAUNCHED]: 'Coach was officially marked as launched.',
    [HistoryEventType.FIRST_LEAD]: 'First lead for coach was recorded.',
    [HistoryEventType.FIRST_SUBSCRIPTION]: 'First subscription for coach was recorded.',
    [HistoryEventType.STRIPE_DEAUTHORIZED]: 'Stripe account was deauthorized.',
    [HistoryEventType.STRIPE_DEAUTHORIZATION_CLEANUP]:
      'Stripe account deauthorization cleanup was performed.',
    [HistoryEventType.OFFBOARDED]: 'Coach was offboarded.',
    [HistoryEventType.POST_PAYMENT_FORM_DELETED]: 'Post-Payment form deleted.',
    [HistoryEventType.COACH_WEBSITE_DELETED]: 'Coach website deleted.',
    [HistoryEventType.APP_ICON_DELETED]: 'App icon deleted.',
    [HistoryEventType.ZOHO_EMAIL_REMOVED]: 'Zoho email removed.',
    [HistoryEventType.LEAD_FORM_ARCHIVED]: 'The lead form was archived.',
    [HistoryEventType.COACH_OFFBOARDING_NOTE_ADDED]: 'The offboarding note was added.',
    [HistoryEventType.COACH_OFFBOARDING_NOTE_EDITED]: 'The offboarding note was updated.',
    [HistoryEventType.SLACK_CHANNEL_ARCHIVED]: 'The Slack channel was archived.',
    [HistoryEventType.SOCIAL_HANDLES_ADDED]: 'Social handles were added.',
    [HistoryEventType.IS_AC_QUESTIONNAIRE_SUBMITTED]: 'The IS & AC Questionnaire was submitted.',
    [HistoryEventType.CONTENT_URLS_SUBMITTED]: 'The Content URLs were submitted.',
    [HistoryEventType.GOOGLE_CALENDAR_CREATED]: 'The Google Calendar was created.',
    [HistoryEventType.COACH_ONBOARDING_FORM_COMPLETED]: 'The Onboarding Form was completed.',
    [HistoryEventType.FIRST_CHAT_MESSAGE_SENT]: 'The first chat message was sent.',
    [HistoryEventType.TRANSFORMATION_POST_SUBMITTED]: 'The Transformation Post was submitted.',
    [HistoryEventType.LAUNCH_POST_SUBMITTED]: 'The Launch Post was submitted.',
    [HistoryEventType.LAUNCH_DATE_EDITED]: 'The Launch Date was edited.',
    [HistoryEventType.AC_FLAG_UPDATED]: 'The AC flag was {status}.',
    [HistoryEventType.IS_FLAG_UPDATED]: 'The IS flag was {status}.',
    [HistoryEventType.FEES_CONFIG_UPDATED]: 'The fees configuration was updated.',
    [HistoryEventType.CAM_ASSIGNMENT_UPDATED]: 'A CAM assignment was {camAction}.',
  },
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled',
  },
  camActionTexts: {
    added: 'added',
    removed: 'removed',
  },
  launchDateChange: ' • New date: {newLaunchDate}. Old date: {oldLaunchDate}.',
  camActionNote: {
    removed: ' • Removed CAM: {userName}',
    added: ' • Added CAM: {userName}',
  },
  feeLabels: {
    baseFee: 'Base Fee',
    insideSalesFee: 'IS Fee',
    assistantCoachFee: 'AC Fee',
  },
  changeTexts: {
    before: 'Before',
    after: 'After',
  },
  arrowIcon: '→',
  naText: 'N/A',
  emptyText: 'No history events found',
};

export default texts;
